import { render, staticRenderFns } from "./PurchaseInfoLedgers.vue?vue&type=template&id=28017a44&scoped=true"
import script from "./PurchaseInfoLedgers.vue?vue&type=script&lang=ts"
export * from "./PurchaseInfoLedgers.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseInfoLedgers.vue?vue&type=style&index=0&id=28017a44&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28017a44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28017a44')) {
      api.createRecord('28017a44', component.options)
    } else {
      api.reload('28017a44', component.options)
    }
    module.hot.accept("./PurchaseInfoLedgers.vue?vue&type=template&id=28017a44&scoped=true", function () {
      api.rerender('28017a44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseInfoLedgers.vue"
export default component.exports